import React from 'react'
import { KibField, type KibFieldProps } from '@chewy/kib-fields-new-react'

import '@chewy/kib-fields-new-styles/dist/styles/kib-field.css'
import styles from './PaymentMethodSection.module.scss'

type NumberFieldProps = Omit<KibFieldProps, 'onChange' | 'min' | 'step'> & {
  isMoney?: boolean
  min?: number
  onChange: (value: string) => void
  step?: string
  validationMessage?: string | null
}

const NumberField = ({
  onChange,
  isMoney = false,
  validationMessage,
  min,
  step,
  value,
  readOnly = false,
  ...kibFieldProps
}: NumberFieldProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  const fieldStep = step || (isMoney ? '0.01' : '1')
  const fieldMin = min !== undefined ? min : isMoney ? 0.01 : 0

  const displayValue =
    readOnly && value && value !== ''
      ? (() => {
          const parsed = parseFloat(value.toString())
          return Number.isNaN(parsed) ? value : parsed.toFixed(2)
        })()
      : value

  return (
    <div className={styles.fieldContainer}>
      <KibField
        {...kibFieldProps}
        messagesContent={
          validationMessage ? (
            <p>{validationMessage}</p>
          ) : (
            kibFieldProps.messagesContent
          )
        }
        min={fieldMin}
        readOnly={readOnly}
        step={fieldStep}
        type="number"
        value={displayValue}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default NumberField
